import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Login from '../../Accounts/Login/Login'
import ForgotPassword from '../../Accounts/ForgotPassword/ForgotPassword'
import ResetPassword from '../../Accounts/ResetPassword/ResetPassword'

function LoginNavigation() {
  return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
  )
}

export default LoginNavigation
